export default {
	AreaChart: {
		vanilla: 'AreaChart',
		angular: 'ibm-area-chart',
		vue: 'ccv-area-chart',
	},
	BoxplotChart: {
		vanilla: 'BoxplotChart',
		angular: 'ibm-boxplot-chart',
		vue: 'ccv-boxplot-chart',
	},
	BubbleChart: {
		vanilla: 'BubbleChart',
		angular: 'ibm-bubble-chart',
		vue: 'ccv-bubble-chart',
	},
	BulletChart: {
		vanilla: 'BulletChart',
		angular: 'ibm-bullet-chart',
		vue: 'ccv-bullet-chart',
	},
	ComboChart: {
		vanilla: 'ComboChart',
		angular: 'ibm-combo-chart',
		vue: 'ccv-combo-chart',
	},
	DonutChart: {
		vanilla: 'DonutChart',
		angular: 'ibm-donut-chart',
		vue: 'ccv-donut-chart',
	},
	GaugeChart: {
		vanilla: 'GaugeChart',
		angular: 'ibm-gauge-chart',
		vue: 'ccv-gauge-chart',
	},
	GroupedBarChart: {
		vanilla: 'GroupedBarChart',
		angular: 'ibm-grouped-bar-chart',
		vue: 'ccv-grouped-bar-chart',
	},
	LineChart: {
		vanilla: 'LineChart',
		angular: 'ibm-line-chart',
		vue: 'ccv-line-chart',
	},
	LollipopChart: {
		vanilla: 'LollipopChart',
		angular: 'ibm-lollipop-chart',
		vue: 'ccv-lollipop-chart',
	},
	MeterChart: {
		vanilla: 'MeterChart',
		angular: 'ibm-meter-chart',
		vue: 'ccv-meter-chart',
	},
	PieChart: {
		vanilla: 'PieChart',
		angular: 'ibm-pie-chart',
		vue: 'ccv-pie-chart',
	},
	RadarChart: {
		vanilla: 'RadarChart',
		angular: 'ibm-radar-chart',
		vue: 'ccv-radar-chart',
	},
	ScatterChart: {
		vanilla: 'ScatterChart',
		angular: 'ibm-scatter-chart',
		vue: 'ccv-scatter-chart',
	},
	SimpleBarChart: {
		vanilla: 'SimpleBarChart',
		angular: 'ibm-simple-bar-chart',
		vue: 'ccv-simple-bar-chart',
	},
	StackedAreaChart: {
		vanilla: 'StackedAreaChart',
		angular: 'ibm-stacked-area-chart',
		vue: 'ccv-stacked-area-chart',
	},
	StackedBarChart: {
		vanilla: 'StackedBarChart',
		angular: 'ibm-stacked-bar-chart',
		vue: 'ccv-stacked-bar-chart',
	},
	TreemapChart: {
		vanilla: 'TreemapChart',
		angular: 'ibm-treemap-chart',
		vue: 'ccv-treemap-chart',
	},
	WordCloudChart: {
		vanilla: 'WordCloudChart',
		angular: 'ibm-wordcloud-chart',
		vue: 'ccv-wordcloud-chart',
	},
};
